"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VerificationMethodType = exports.BitwiseVerificationMethodFlag = void 0;
var BitwiseVerificationMethodFlag;
(function (BitwiseVerificationMethodFlag) {
    BitwiseVerificationMethodFlag[BitwiseVerificationMethodFlag["Authentication"] = 1] = "Authentication";
    BitwiseVerificationMethodFlag[BitwiseVerificationMethodFlag["Assertion"] = 2] = "Assertion";
    BitwiseVerificationMethodFlag[BitwiseVerificationMethodFlag["KeyAgreement"] = 4] = "KeyAgreement";
    BitwiseVerificationMethodFlag[BitwiseVerificationMethodFlag["CapabilityInvocation"] = 8] = "CapabilityInvocation";
    BitwiseVerificationMethodFlag[BitwiseVerificationMethodFlag["CapabilityDelegation"] = 16] = "CapabilityDelegation";
    BitwiseVerificationMethodFlag[BitwiseVerificationMethodFlag["DidDocHidden"] = 32] = "DidDocHidden";
    BitwiseVerificationMethodFlag[BitwiseVerificationMethodFlag["OwnershipProof"] = 64] = "OwnershipProof";
})(BitwiseVerificationMethodFlag = exports.BitwiseVerificationMethodFlag || (exports.BitwiseVerificationMethodFlag = {}));
var VerificationMethodType;
(function (VerificationMethodType) {
    // The main Ed25519Verification Method.
    // https://w3c-ccg.github.io/lds-ed25519-2018/
    VerificationMethodType[VerificationMethodType["Ed25519VerificationKey2018"] = 0] = "Ed25519VerificationKey2018";
    // Verification Method for For 20-bytes Ethereum Keys
    VerificationMethodType[VerificationMethodType["EcdsaSecp256k1RecoveryMethod2020"] = 1] = "EcdsaSecp256k1RecoveryMethod2020";
    // Verification Method for a full 32 bytes Secp256k1 Verification Key
    VerificationMethodType[VerificationMethodType["EcdsaSecp256k1VerificationKey2019"] = 2] = "EcdsaSecp256k1VerificationKey2019";
})(VerificationMethodType = exports.VerificationMethodType || (exports.VerificationMethodType = {}));
//# sourceMappingURL=types.js.map